namespace app.legacy {

    /** @ngInject */
    function configUiSrefActiveDecorator($provide: ng.auto.IProvideService) {
        $provide.decorator('uiSrefDirective', ($delegate, $rootScope) => {
            let directive = $delegate[0];
            directive.compile = () => {
                return (scope, element, attrs, ctrl) => {
                    var linkResult = directive.link(scope, element, attrs, ctrl);
                    $rootScope.$on("legacyRouteChanged", () => {
                        scope.$broadcast("$stateChangeSuccess");
                    });
                    return linkResult;
                }
            };
            
            return $delegate;
        });
    }

    angular.module('app.legacy').config(configUiSrefActiveDecorator);

}